'use strict';

export default [
  function() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        const phonePattern = '+7 (___) ___-__-__';
        
        // Форматируем номер
        function format(value) {
          if (!value) return phonePattern;

          const numbers = value.toString().replace(/\D/g, ''); // Убираем все нецифровые символы
          let result = phonePattern;

          // Проверяем, начинается ли номер с 7 или 8
          if (numbers.length > 0 && (numbers[0] === '7' || numbers[0] === '8')) {
            result = result.replace('7', numbers[0]);
          }

          // Заполняем шаблон цифрами
          let j = 0;
          for (let i = 1; i < numbers.length && i < 11; i++) {
            result = result.replace('_', numbers[i]);
          }

          return result;
        }

        // Преобразуем в формат для модели
        function parse(value) {
          if (!value) return '';
          return value.replace(/\D/g, ''); // Убираем все нецифровые символы
        }

        ngModel.$formatters.push(format);
        ngModel.$parsers.push(parse);

        element.on('input', function(event) {
          let cursorPos = element[0].selectionStart;
          const oldValue = element.val();
          
          // Определяем позицию курсора относительно цифр
          const valueBeforeCursor = oldValue.slice(0, cursorPos);
          const digitsBeforeCursor = valueBeforeCursor.replace(/\D/g, '').length;
          
          // Определяем, было ли это удалением
          const isDelete = event.originalEvent?.inputType === 'deleteContentBackward';

          // Форматируем текущее значение
          let val = format(element.val());

          element.val(val);
          ngModel.$setViewValue(val);

          // Корректировка позиции курсора
          const specialChars = [' ', '(', ')', '-'];

          if (isDelete) {
            // При удалении проверяем следующий символ
            if (specialChars.includes(val[cursorPos - 1]) || val[cursorPos - 1] === '_') {
              cursorPos--;
            }
          } else {
            // При добавлении находим позицию после нужного количества цифр
            let digitCount = 0;
            cursorPos = 0;
            while (cursorPos < val.length && digitCount < digitsBeforeCursor) {
              if (!/[\D_]/.test(val[cursorPos])) {
                digitCount++;
              }
              cursorPos++;
            }
          }

          // Не даем курсору стоять в первых трех символах (+7_)
          if (cursorPos <= 3) {
            cursorPos = 3;
          }

          element[0].setSelectionRange(cursorPos, cursorPos);
        });
      }
    };
  }
];
